export default __webpack_public_path__ + "static/media/setaVermelhaGrande.e4f6f630.png";